import axios from 'axios'
import store from '../store'
import Environment from "./environment";

const AxiosInstance = axios.create();
AxiosInstance.defaults.baseURL = process.env.BASE_URL;

AxiosInstance.interceptors.request.use(request => {
  const token = store.getters['auth/token'];
  if (token) {
    request.headers.common['token'] = `${token}`
  }

  const resource = store.getters['resource/resource_key'] || Environment.getOuterResourceId();
  if (resource) {
    request.headers.common['resource'] = resource;
  }

  request.headers.common['Wallkit-Client'] = `Popups v${process.env.PACKAGE_VERSION}`;

  return request
});

AxiosInstance.interceptors.response.use(null, async error => {
  let res = error.response;

  if (typeof res.status !== "undefined") {
    if (res.status === 401) {
      store.dispatch('auth/removeToken');
    }
  }

  return Promise.reject(error);
});

export default AxiosInstance;



// WEBPACK FOOTER //
// ./src/utils/axios.js